import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuelidate from "vuelidate";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

import VueAnalytics from 'vue-analytics';

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
    id: "UA-32522234-2",
    router,
    autoTracking: {
        exception: true
    }
});

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
